import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Body2, mergeClasses, Title2 } from '@fluentui/react-components';

import { BrandActionCards } from './action-cards';
import { useBannerContainerStyles } from './styles';

const Banner = ({ i18n, hideActionsMenu }) => {
  const classes = useBannerContainerStyles();

  return (
    <div className={mergeClasses(
      'ads-studio-top-banner-container',
      classes.bannerContainer
    )}
    >
      <div>
        <Title2 as="h1" className={mergeClasses('brand-kit-banner-title', classes.heading)} block>
          {i18n.getString(_TL_('Brand kit'))}
        </Title2>
        <Body2 as="p" className="brand-kit-banner-description">
          {i18n.getString(_TL_('Add and manage your brand identity for your ads, all in one place.'))}
        </Body2>
      </div>
      {hideActionsMenu ? null : <BrandActionCards i18n={i18n} />}
    </div>
  );
};

export { Banner };

Banner.propTypes = {
  i18n: PropTypes.shape({ getString: func }).isRequired,
  hideActionsMenu: PropTypes.bool,
};

Banner.defaultProps = {
  hideActionsMenu: false,
};
